
import { Component, Input, OnInit } from '@angular/core';
import { Race } from 'src/app/models/race';
import { RaceProgressRegistration } from 'src/app/models/race_progress_registration';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-competitor-info',
  templateUrl: './competitor-info.component.html',
  styleUrls: ['./competitor-info.component.scss']
})
export class CompetitorInfoComponent implements OnInit {

  @Input() competitor!: RaceProgressRegistration;
  @Input() TVResume: boolean = false;
  @Input() selectedRace!: Race;
  @Input() minimize: boolean = false;
  timeFormat = 'HH:mm:ss';
  constructor(public appSettings: SettingsService) { }

  ngOnInit() {
    if (this.selectedRace && this.selectedRace.showMillsInResults) this.timeFormat = 'HH:mm:ss.SSS';
  }

}
